"use client";
import styles from "@/app/styles/contract.module.scss";
import { useRef } from "react";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Link from "next/link";
import contactData from "@/data/contact";
import Image from "next/image";

gsap.registerPlugin(ScrollTrigger);

const ContractSection = () => {
  const sectionRef = useRef(null);
  const textRef = useRef(null);
  const buttonRef = useRef(null);
  useGSAP(
    () => {
      gsap.fromTo(
        textRef.current,
        { opacity: 0, y: -50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
      gsap.fromTo(
        buttonRef.current,
        { opacity: 0, y: 50 },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 70%",
            end: "bottom 20%",
            toggleActions: "play none none none",
          },
        }
      );
    },
    { scope: sectionRef }
  );
  return (
    <section className={styles.ContractSection} ref={sectionRef}>
      <div
        className={styles.backgroundLayer}
      >
        <Image
          src="/Call-to-Action.webp"
          alt="call to action image"
          width={1920}
          height={1080}
          quality={100}
          priority
          style={{ objectFit: "cover" }}
        ></Image>
      </div>
      <div className={styles.cta}>
        <div ref={textRef} className="pointer-events-none">
          <h2>Ready to create your cozy retreat?</h2>
          <p>พร้อมจะสร้างมุมพักผ่อนแสนอบอุ่นของคุณแล้วหรือยัง</p>
        </div>
        <Link
          href={`https://line.me/R/ti/p/${contactData.lineID}`}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.contact_btn}
          ref={buttonRef}
        >
          ปรึกษาทีมงาน
        </Link>
      </div>
    </section>
  );
};

export default ContractSection;
